import { useMutation, useQuery } from "react-query"
import DataService from '../../../config/DataServices'
import { useToast } from "../../../hooks/usetoast"
import { queryClient } from "../../../config"

const { getRequest, putRequest, postRequest, deleteRequest } = DataService()
export const useCms = ({ page, size, searchText, sortOrder, sortField }) => {

    return useQuery({
        queryKey: ["cms", page, size, searchText, sortOrder, sortField],
        queryFn: () => {
            return getRequest(`/cms?page=${page}&size=${size}&search=${searchText}&sortOrder=${sortOrder}&sortField=${sortField}`)
        }
    })
}


export const useUpdateCms = () => {
    return useMutation({
        mutationFn: (data) => {
            return putRequest(`/cms/${data.get("id")}`, data)
        },
    })
}

export const useAddCms = () => {

    return useMutation({
        mutationFn: (data) => {
            return postRequest("/cms/addCms", data)
        },

    })
}

export const useDeleteCms = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: (data) => {
            return deleteRequest(`/cms/cms/${data._id}`)
        },
        onSuccess: success => {
            if (!success?.status) {
                return toast.error(success?.message)
            }
            queryClient.refetchQueries("cms");
            return toast.success(success?.message)
        }
    })
}

export const useGetHomeCms = () => {

    return useQuery({
        queryKey: ["cms"],
        queryFn: () => {
            return getRequest('/home-cms')
        }
    })
}

export const useGetCardCms = () => {

    return useQuery({
        queryKey: ["cms"],
        queryFn: () => {
            return getRequest('/card/view-agreement-policy')
        }
    })
}
